/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Logger } from "cms/utils/log/logger";

/**
 * validateModelChanged
 *
 * @param state
 * @param nextState
 */
export const validateModelChanged = (state, nextState) => {
    const originalState = { ...state }; // de-proxy - immer
    const guid = originalState.guid;
    const guid2 = nextState?.guid;
    const fields = [...originalState.fieldsState]; // de-proxy - immer
    const fields2 = nextState?.fields;
    const isSameGuid = guid === guid2;
    if (!isSameGuid) {
        // the guid would change when a different model is loaded
        // this really avoids it seeming like there was a new model, when we update a model
        Logger.info(`[initFieldState] ${guid2} modified (new guid)`);
        return true;
    } else {
        for (let i=0; i<fields.length; i++) {
            // name and position of fields in a model do not change in April 2025. 
            // but this verifies that we have the same model structure
            const name = fields[i]?.name;
            const name2 = fields2[i]?.name;
            const position = i+1;
            const position2 = fields[i]?.position;
            const isNameEqual = name === name2;
            if (!isNameEqual) {
                // Logger.info(`[initFieldState] ${guid2} name ${name} -> name changed ${name}/${name2}`)
                return true;
            }
            const isPositionEqual = position === position2;
            if (!isPositionEqual) {
                // Logger.info(`[initFieldState] ${guid2} name ${name} -> position changed ${position}/${position2}`)
                return true;
            }
            const isEqual = isNameEqual && isPositionEqual;
            if (!isEqual) {
                // Logger.info(`[initFieldState] ${guid2} modified `)
                return true;
            }
        }
        // Logger.info(`[initFieldState] ${guid2} not changed`)
        return false;
    }
};
